import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DonorCountPerCampaignBarChart = ({ data, width = 433, height = 251 }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;

    const labels = data.map((item) => item.collectionSiteName);
    const donorCounts = data.map((item) => item.donorCount);

    return {
      labels,
      datasets: [
        {
          label: t("Donor Count"),
          data: donorCounts,
          backgroundColor: "#3b4cb8",
          borderColor: "#3b4cb8",
          borderWidth: 1,
        },
      ],
    };
  }, [data, t]);

  const totalDonors = useMemo(() => {
    if (!data || !Array.isArray(data)) return 0;
    return data.reduce((sum, item) => sum + item.donorCount, 0);
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        title: (tooltipItems) => {
          const index = tooltipItems[0].index;
          const item = data[index];
          return item.collectionSiteName;
        },
        label: (tooltipItem) => {
          const raw = tooltipItem.yLabel;
          const percentage = totalDonors > 0 ? ((raw / totalDonors) * 100).toFixed(2) : 0;
          return `${t("Donors")}: ${raw} (${percentage}%)`;
        },
      },
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          fontColor: "#999"
        },
        scaleLabel: {
          display: true,
          labelString: t("Number of Donors"),
          fontColor: "#666"
        },
      }],
      xAxes: [{
        ticks: {
          fontColor: "#999",
          maxRotation: 45,
          minRotation: 45,
        },
        scaleLabel: {
          display: true,
          labelString: t("Collection Site"),
          fontColor: "#666"
        },
      }],
    },
  };

  if (!chartData)
    return <p className="text-center mt-3">{t("No chart data available")}</p>;

  return (
    <div style={{ minHeight: "290px" }}>
      <Bar data={chartData} width={width} height={height} options={options} />
    </div>
  );
};

export default DonorCountPerCampaignBarChart;
